import React from "react";
import { Box } from "@mui/material";
import PropTypes from "prop-types";

/**
 * This is the DragDropStyledContainer component that is used to create a drag and drop area for files.
 * It uses the Box component from Material UI to create a styled container.
 * It accepts children as props and applies drag and drop styles to the container. 
 * @param {Object} props - The props object.
 * @param {ReactNode} props.children - The children to be rendered inside the container.
 * @returns {JSX.Element} - The rendered component.
 */
export const DragDropStyledContainer = ({ children }) => {
	const myElement = React.useRef(null);
	const handleDragEnter = () => myElement.current.classList.add("drag-drop-cls");
	const handleDragOver = () => myElement.current.classList.remove("drag-drop-cls");

	return (
		<Box ref={myElement} onDragEnter={handleDragEnter} onDragLeave={handleDragOver} onDrop={handleDragOver}>
			{children}
		</Box>
	);
};
DragDropStyledContainer.propTypes = {
	children: PropTypes.node.isRequired,
};
